import React from "react";
import { PropsWithChildren, isValidElement } from "react";

/**
 * A special type of container designed to
 * arrange multiple elements into a single row
 * with no spacing.
 */
const InlineContainer = ({
  children,
  className
}: PropsWithChildren<{ className?: string }>) => (
  <article className={"flex items-stretch " + className}>
    {/* Loop through children to adjust corner radius & border */}
    {React.Children.map(children, (child, index) => {
      if (isValidElement(child) && "props" in child) {
        return React.createElement(child.type, {
          ...child.props,
          className:
            child.props.className +
            " !rounded-none w-full " +
            (index === 0 ? "!rounded-l-md " : "") +
            (index === React.Children.count(children) - 1
              ? "!rounded-r-md"
              : "border-r-0") +
            (!!child.props.disabled && index !== 0
              ? " border-l-1 !border-l-ctb-blue-400"
              : "")
        });
      }

      return child;
    })}
  </article>
);

export default InlineContainer;
